<div class="bg-image"></div>
<div style="z-index: 10000; position: absolute; width: 100%">
    <alert></alert>
    <div *ngIf="!isCheckAvailable" class="alert alert-danger text-center">
        O sistema está temporariamente indisponível. Tente novamente em
        instantes.

        <a
            class="ml-4 btn btn-danger material-button"
            (click)="reload()"
            data-toggle="tooltip"
            placement="top"
            ngbTooltip="Recarregar">
            <span class="material-icons md-21 py-1">refresh</span>
        </a>
    </div>
</div>
<div class="d-flex flex-row justify-content-center min-vh-100">
    <div class="d-flex flex-column justify-content-center">
        <div
            class="d-flex align-items-start rounded-top"
            [ngClass]="{ 'dev-theme': isdev, 'bg-blue': !isdev }">
            <div class="align-self-center">
                <img
                    src="assets/images/logo_lccv.png"
                    class="img-fluid"
                    width="100px" />
            </div>
            <div class="align-self-center flex-column">
                <div class="text-light my-auto title-sm">Sumé</div>
                <span class="badge badge-light">
                    <div class="text-bold">
                        {{
                            isdev
                                ? 'Ambiente de testes'
                                : 'Ambiente integrado de gestão'
                        }}
                    </div>
                </span>
            </div>
        </div>
        <div class="px-3 py-2 bg-gray rounded-bottom">
            <form
                class="form-validate"
                [formGroup]="loginForm"
                (ngSubmit)="onSubmit()"
                id="form-container">
                <div class="form-group">
                    <sume-input
                        type="text"
                        mask="000.000.000-00"
                        label="CPF"
                        controlName="username"
                        [formGroup]="loginForm"
                        placeholder="000.000.000-00"
                        autocomplete="off"
                        autofocus></sume-input>
                </div>
                <div class="form-group mb-4">
                    <div class="row">
                        <div class="col">
                            <label class="form-control-label">Senha</label>
                            <div class="input-group" id="show_hide_password">
                                <input
                                    [type]="show_password ? 'text' : 'password'"
                                    formControlName="password"
                                    class="form-control"
                                    [ngClass]="{
                                        'is-invalid':
                                            submitted && f.password.errors
                                    }" />
                                <div class="input-group-addon">
                                    <button
                                        type="button"
                                        class="btn btn-primary px-2 pwd-visibility"
                                        (click)="
                                            show_password = !show_password
                                        ">
                                        <i
                                            class="fa"
                                            [ngClass]="{
                                                'fa-eye-slash': !show_password,
                                                'fa-eye': show_password
                                            }"
                                            aria-hidden="true"></i>
                                    </button>
                                </div>
                                <div
                                    *ngIf="submitted && f.password.errors"
                                    class="invalid-feedback">
                                    <div *ngIf="f.password.errors.required">
                                        Digite a senha
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div [hidden]="!err_msg" class="alert alert-danger">
                    {{ err_msg }}
                </div>
                <!-- Submit-->
                <button
                    [disabled]="loading || !loginForm.valid"
                    type="submit"
                    class="btn btn-lg btn-block btn-primary mb-3 text-center"
                    [ngClass]="{ 'bg-blue': !isdev, 'dev-theme': isdev }">
                    <span
                        *ngIf="loading"
                        class="spinner-border spinner-border-sm my-1"></span>
                    Login
                </button>
            </form>

            <!-- esqueci minha senha -->

            <div>
                <button
                    (click)="open(modalSenha)"
                    #abrirModal
                    [disabled]="
                        !loginForm.get('username').value ||
                        loginForm.get('username').value.length < 11
                    "
                    class="style-hover style-botton">
                    <h6>Esqueci minha senha</h6>
                </button>
                <ngx-spinner
                    [fullScreen]="true"
                    type="ball-scale-multiple"
                    size="medium"></ngx-spinner>
            </div>

            <!-- modal de confirmação para redefinir senha -->
            <ng-template #modalSenha let-modal>
                <div class="modal-header">
                    <h4 class="modal-title">Deseja gerar nova senha?</h4>
                    <button
                        type="button"
                        class="close"
                        aria-label="Close"
                        (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <p>
                        Uma nova senha será gerada automaticamente e enviada
                        para seu e-mail.
                    </p>
                    <p>Esta ação não poderá ser desfeita. Deseja continuar?</p>
                </div>

                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-danger material-button"
                        (click)="modal.close('Close click')">
                        Fechar
                    </button>

                    <button
                        type="button"
                        class="btn btn-success material-button"
                        (click)="redefinirSenha()"
                        (click)="modal.dismiss('Cross click')">
                        Continuar
                    </button>
                </div>
            </ng-template>

            <div class="d-flex justify-content-between align-items-center">
                <version-modal></version-modal>
                <button
                    class="btn btn-sm btn-outline-dark"
                    (click)="darkThemeService.onDarkMode()">
                    <div class="d-flex">
                        <span class="material-icons">
                            {{
                                darkThemeService.enabled
                                    ? 'brightness_high'
                                    : 'brightness_medium'
                            }}
                        </span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</div>
